// src/app/redux/sagas/paramAvantagesSociauxSaga.js
import { all, call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

import {
    setParamAvantagesLoading,

    fetchParamAvantagesSuccess,
    fetchParamAvantagesFail,

    createAvCatSuccess,
    createAvCatFail,
    updateAvCatSuccess,
    updateAvCatFail,
    deleteAvCatSuccess,
    deleteAvCatFail,

    createAvRegleSuccess,
    createAvRegleFail,
    updateAvRegleSuccess,
    updateAvRegleFail,
    deleteAvRegleSuccess,
    deleteAvRegleFail,

    createAvantageSuccess,
    createAvantageFail,
    updateAvantageSuccess,
    updateAvantageFail,
    deleteAvantageSuccess,
    deleteAvantageFail, fetchParamAvantagesRequest,
} from "../actions/paramAvantagesActions";

const extractErrorMessage = (error, fallback) => {
    let msg = fallback;
    if (error?.response?.data?.message) msg = error.response.data.message;
    else if (error?.response?.data?.error) msg = error.response.data.error;
    else if (error?.message) msg = error.message;
    return msg;
};

const normalizeFrequence = (v) => {
    if (!v) return v;
    const s = String(v).toUpperCase();
    // support "mensuel" => "MENSUEL"
    if (s.includes("MENS")) return "MENSUEL";
    if (s.includes("ANN")) return "ANNUEL";
    if (s === "JOUR" || s.includes("JOUR")) return "JOUR";
    if (s.includes("UNIQ")) return "UNIQUE";
    return s; // fallback
};

// ===================== FETCH ALL =====================
export function* fetchParamAvantagesSaga() {
    const token = sessionStorage.getItem("token");

    const urlCats = `${API_BASE_URL}/api/paramavantages/categories`;
    const urlRegles = `${API_BASE_URL}/api/paramavantages/regles`;
    const urlAvs = `${API_BASE_URL}/api/paramavantages/avantages`;

    yield put(setParamAvantagesLoading(true));

    try {
        const [catsResp, reglesResp, avsResp] = yield all([
            call(getRequest, { url: urlCats, token }),
            call(getRequest, { url: urlRegles, token }),
            call(getRequest, { url: urlAvs, token }),
        ]);
        const unwrap = (resp) => (resp && typeof resp === "object" && "data" in resp ? resp.data : resp);
        const payload = {
            categories: unwrap(catsResp) || [],
            regles: unwrap(reglesResp) || [],
            avantages: unwrap(avsResp) || [],
        };

        yield put(fetchParamAvantagesSuccess(payload));

        yield put(setParamAvantagesLoading(false));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement paramètres avantages");
        yield put(fetchParamAvantagesFail(msg));
        yield put(setParamAvantagesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    }
}

// ===================== CATEGORIES =====================
export function* createAvCatSaga(action) {
    const token = sessionStorage.getItem("token");
    const url = `${API_BASE_URL}/api/paramavantages/categories`;
    const data = action.payload;

    yield put(setParamAvantagesLoading(true));
    try {
        const resp = yield call(postRequest, { url, data, token });
        yield put(createAvCatSuccess(resp.data));
        yield put(fetchParamAvantagesRequest());
        yield put(setParamAvantagesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Catégorie ajoutée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur ajout catégorie");
        yield put(createAvCatFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

export function* updateAvCatSaga(action) {
    const token = sessionStorage.getItem("token");
    const { id, payload } = action.payload;
    const data = payload;

    const url = `${API_BASE_URL}/api/paramavantages/categories/${id}`;

    yield put(setParamAvantagesLoading(true));
    try {
        const resp = yield call(putRequest, { url, data, token });
        yield put(updateAvCatSuccess(resp.data));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "success", title: "", text: "Catégorie modifiée", timer: 1400, showConfirmButton: false });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur mise à jour catégorie");
        yield put(updateAvCatFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

export function* deleteAvCatSaga(action) {
    const token = sessionStorage.getItem("token");
    const id = action.payload;
    const url = `${API_BASE_URL}/api/paramavantages/categories/${id}`;

    yield put(setParamAvantagesLoading(true));
    try {
        yield call(deleteRequest, { url, token });
        yield put(deleteAvCatSuccess(id));
        yield put(setParamAvantagesLoading(false));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur suppression catégorie");
        yield put(deleteAvCatFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

// ===================== REGLES =====================
export function* createAvRegleSaga(action) {
    const token = sessionStorage.getItem("token");
    const url = `${API_BASE_URL}/api/paramavantages/regles`;
    const data = action.payload;

    yield put(setParamAvantagesLoading(true));
    try {
        const resp = yield call(postRequest, { url, data, token });
        yield put(createAvRegleSuccess(resp.data));
        yield put(setParamAvantagesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Règle ajoutée",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur ajout règle");
        yield put(createAvRegleFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

export function* updateAvRegleSaga(action) {
    const token = sessionStorage.getItem("token");
    const { id, payload } = action.payload;
    const data = payload;

    const url = `${API_BASE_URL}/api/paramavantages/regles/${id}`;

    yield put(setParamAvantagesLoading(true));
    try {
        const resp = yield call(putRequest, { url, data, token });
        yield put(updateAvRegleSuccess(resp.data));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "success", title: "", text: "Règle modifiée", timer: 1400, showConfirmButton: false });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur mise à jour règle");
        yield put(updateAvRegleFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

export function* deleteAvRegleSaga(action) {
    const token = sessionStorage.getItem("token");
    const id = action.payload;
    const url = `${API_BASE_URL}/api/paramavantages/regles/${id}`;

    yield put(setParamAvantagesLoading(true));
    try {
        yield call(deleteRequest, { url, token });
        yield put(deleteAvRegleSuccess(id));
        yield put(setParamAvantagesLoading(false));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur suppression règle");
        yield put(deleteAvRegleFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

// ===================== AVANTAGES =====================
// Backend expects: { categorieId, regleId, nom, code, description, montant, frequence, actif }
export function* createAvantageSaga(action) {
    const token = sessionStorage.getItem("token");
    const url = `${API_BASE_URL}/api/paramavantages/avantages`;

    const payload = action.payload || {};
    const data = {
        ...payload,
        frequence: normalizeFrequence(payload.frequence),
    };

    yield put(setParamAvantagesLoading(true));
    try {
        const resp = yield call(postRequest, { url, data, token });
        yield put(createAvantageSuccess(resp.data));
        yield put(setParamAvantagesLoading(false));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Avantage ajouté",
            timer: 1400,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur ajout avantage");
        yield put(createAvantageFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

export function* updateAvantageSaga(action) {
    const token = sessionStorage.getItem("token");
    const { id, payload } = action.payload;
    const url = `${API_BASE_URL}/api/paramavantages/avantages/${id}`;

    const data = {
        ...payload,
        frequence: normalizeFrequence(payload.frequence),
    };

    yield put(setParamAvantagesLoading(true));
    try {
        const resp = yield call(putRequest, { url, data, token });
        yield put(updateAvantageSuccess(resp.data));
        yield put(setParamAvantagesLoading(false));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur mise à jour avantage");
        yield put(updateAvantageFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}

export function* deleteAvantageSaga(action) {
    const token = sessionStorage.getItem("token");
    const id = action.payload;
    const url = `${API_BASE_URL}/api/paramavantages/avantages/${id}`;

    yield put(setParamAvantagesLoading(true));
    try {
        yield call(deleteRequest, { url, token });
        yield put(deleteAvantageSuccess(id));
        yield put(setParamAvantagesLoading(false));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur suppression avantage");
        yield put(deleteAvantageFail(msg));
        yield put(setParamAvantagesLoading(false));
        yield call([Swal, Swal.fire], { icon: "error", title: "Erreur", text: msg });
    }
}
